// 西班牙语言
import es from './JsonLang/es.json'
import esSpec from './JsonLangSpec/es.json'
export const lang = {
    ...es, ...esSpec
}